module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hrms15e-popup-course2",
      "id": "hrms15e-popup-course2",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC32']['160']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('hrms-table', {
    ref: "popupCourse",
    attrs: {
      "columns": _vm.courseGapPopupTable,
      "data": _vm.popupCourseGap,
      "searchDisp": false,
      "selectRowBool": false,
      "selectBtnDisp": true,
      "selectEvent": _vm.selectEvent,
      "confirmSelectBtnDisp": false
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn bg-color-skin pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.triggerCourse()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['ok']))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ca9f084!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms15e/popupCourseGap2.vue
// module id = 3552
// module chunks = 1